import axiosClient from "../../../../axiosClient"

export default async (id) => {
    const result = await axiosClient.get(`/background-check-client-form-data/${id}`)

    return result.data
}
